import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "15",
  fill: "currentColor",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.591 1.032a2.25 2.25 0 0 0-3.182 0L2.107 9.334c-.308.308-.52.7-.61 1.126l-.735 3.485a.75.75 0 0 0 .888.889l3.485-.735a2.25 2.25 0 0 0 1.127-.61l8.301-8.303a2.25 2.25 0 0 0 0-3.182zm-2.121 1.06a.75.75 0 0 1 1.06 0l.973.973a.75.75 0 0 1 0 1.06l-.899.9-2.033-2.034zm-1.96 1.96-6.342 6.343a.75.75 0 0 0-.203.375l-.498 2.358 2.358-.497a.75.75 0 0 0 .376-.204l6.343-6.342z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }